import { BaseComponent } from "../../BaseComponent.js";
import "../../atom/Row/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { html } from "lit";
import { queryAssignedElements } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfFilterGroup = class extends BaseComponent {
  onSlotChange() {
    const width = 100 / this.slottedElements.length;
    this.slottedElements.forEach((elm, idx, arr) => {
      elm.style.width = `${width}%`;
      elm.setAttribute("_dsf_grouped", this.getPosition(idx, arr.length));
    });
  }
  getPosition(idx, total) {
    if (idx === 0) {
      return "first";
    } else if (idx === total - 1) {
      return "last";
    }
    return "middle";
  }
  render() {
    return html` <dsf-row>
      <slot @slotchange=${this.onSlotChange}></slot>
    </dsf-row>`;
  }
};
__decorateClass([
  queryAssignedElements()
], DsfFilterGroup.prototype, "slottedElements", 2);
DsfFilterGroup = __decorateClass([
  defineElement("dsf-filter-group")
], DsfFilterGroup);
export {
  DsfFilterGroup
};
